import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
export var detectQuietMainThread = function(maxQuietWindowWaitTimeMs, frameLatencyThresholdMs, abortNotifier, ignoreAbortReasons) {
    return new Promise(function(resolve) {
        var _getWindowOrThrow = getWindowOrThrow(), document = _getWindowOrThrow.document, requestAnimationFrame = _getWindowOrThrow.requestAnimationFrame, cancelAnimationFrame = _getWindowOrThrow.cancelAnimationFrame, performance = _getWindowOrThrow.performance;
        var onVisibilityChange = function() {
            if (document.visibilityState !== "visible") {
                cleanupAndResolve({
                    status: "page-hidden"
                });
            }
        };
        var cleanupAndResolve = function(result) {
            document.removeEventListener("visibilitychange", onVisibilityChange);
            if (rafHandle != null) {
                cancelAnimationFrame(rafHandle);
            }
            resolve(result);
        };
        var startOfQuietWindow = performance.now();
        var startOfTracking = startOfQuietWindow;
        var rafHandle = null;
        var lastFrame = startOfQuietWindow;
        var frameDurations = [];
        var onNextFrame = function() {
            var thisFrame = performance.now();
            var actualInterval = thisFrame - lastFrame;
            frameDurations.push(actualInterval);
            if (actualInterval >= frameLatencyThresholdMs) {
                // Long task detected, reset the window start time
                startOfQuietWindow = thisFrame;
            }
            if (thisFrame - startOfQuietWindow < maxQuietWindowWaitTimeMs) {
                lastFrame = thisFrame;
                rafHandle = requestAnimationFrame(onNextFrame);
            } else {
                cleanupAndResolve({
                    startOfQuietWindow: startOfQuietWindow,
                    status: "success",
                    startOfTracking: startOfTracking,
                    frameDurations: frameDurations
                });
            }
        };
        if (abortNotifier === null || abortNotifier === void 0 ? void 0 : abortNotifier.aborted) {
            if (!(ignoreAbortReasons === null || ignoreAbortReasons === void 0 ? void 0 : ignoreAbortReasons.includes(abortNotifier === null || abortNotifier === void 0 ? void 0 : abortNotifier.reason))) {
                resolve({
                    status: "aborted"
                });
            }
        } else if (document.visibilityState !== "visible") {
            resolve({
                status: "page-hidden"
            });
        } else {
            abortNotifier === null || abortNotifier === void 0 ? void 0 : abortNotifier.addAbortListener(function(reason) {
                if (!reason || !(ignoreAbortReasons === null || ignoreAbortReasons === void 0 ? void 0 : ignoreAbortReasons.includes(reason))) {
                    cleanupAndResolve({
                        status: "aborted"
                    });
                }
            });
            document.addEventListener("visibilitychange", onVisibilityChange);
            rafHandle = requestAnimationFrame(onNextFrame);
        }
    });
};
